
import React, { useState } from "react";

export default function PdgWindow({
  title,
  children,
  onClose,
  width = "800px",
  height = "560px",
  className = "",
}) {
  const [isMaximized, setIsMaximized] = useState(false);

  return (
    <div
      className={[
        "absolute bg-slate-900/95 border border-white/20 rounded-lg overflow-hidden shadow-2xl flex flex-col",
        isMaximized ? "inset-4" : "",
        className,
      ].join(" ")}
      style={
        !isMaximized
          ? {
            width,
            // Ne jamais dépasser 85% de la hauteur de l'écran
            height,
            maxHeight: "85vh",
            top: "5%",
            left: "50%",
            transform: "translateX(-50%)",
          }
          : {}
      }
    >
      {/* Barre de titre */}
      <div className="flex-shrink-0 flex items-center justify-between px-3 py-2 bg-slate-800/90 border-b border-white/10">
        <div className="text-sm font-semibold text-white">{title}</div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setIsMaximized(!isMaximized)}
            className="w-6 h-6 rounded bg-yellow-500/20 hover:bg-yellow-500/40 border border-yellow-400/40 flex items-center justify-center text-yellow-200 text-xs transition"
            title={isMaximized ? "Restaurer" : "Agrandir"}
          >
            {isMaximized ? "🗗" : "🗖"}
          </button>
          <button
            onClick={onClose}
            className="w-6 h-6 rounded bg-red-500/20 hover:bg-red-500/40 border border-red-400/40 flex items-center justify-center text-red-200 text-xs transition"
            title="Fermer"
          >
            ✕
          </button>
        </div>
      </div>

      {/* Contenu : flex-1 + min-h-0 pour que overflow-auto fonctionne */}
      <div className="flex-1 min-h-0 overflow-hidden">{children}</div>
    </div>
  );
}